var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownGlassTubeFullClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 100,
    viewBox: "0 0 33 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H25V91.7662C25 95.209 21.9779 98 18.25 98H13.75C10.0221 98 7 95.209 7 91.7662V18Z",
    fill: "#462316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H23V90.8658C23 93.7013 20.7614 96 18 96H14C11.2386 96 9 93.7013 9 90.8658V18Z",
    fill: "#7D5547"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#462316"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 35H23V90.6056C23 93.5848 20.7614 96 18 96H14C11.2386 96 9 93.5848 9 90.6056V35Z",
    fill: "#291906"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H24L23 16V20H9V16L8 10Z",
    fill: "#DA9038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H25L23 16V20H21V16L22 10Z",
    fill: "#C47519"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 10H7L8.9999 16.2827V20H11L11.0796 16.2827L10.0397 10Z",
    fill: "#F0B168"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 14,
    height: 2,
    fill: "#33170C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 16.4477 20.4477 16 21 16H24V18H21C20.4477 18 20 17.5523 20 17V17Z",
    fill: "#291906"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 43,
    width: 15,
    height: 19,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 43,
    width: 2,
    height: 19,
    fill: "#EEEEEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 43,
    width: 1,
    height: 19,
    fill: "#CCCCCC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 43,
    width: 1,
    height: 19,
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownGlassTubeFullClosed);
export default __webpack_public_path__ + "static/media/brown_glass_tube_full_closed.a95f1373027a32411f30edc94e486989.svg";
export { ForwardRef as ReactComponent };